import { render, staticRenderFns } from "./enfooter.vue?vue&type=template&id=ce9e674a&scoped=true&"
import script from "./enfooter.vue?vue&type=script&lang=js&"
export * from "./enfooter.vue?vue&type=script&lang=js&"
import style0 from "./enfooter.vue?vue&type=style&index=0&id=ce9e674a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9e674a",
  null
  
)

export default component.exports